import * as components from './components'

export default [
  {
    path: '/career/:code/home',
    component: components.CareerHome,
    name: 'careerHome',
    props: true
  },
  {
    path: '/career/:code/related',
    component: components.RelatedCareers,
    name: 'relatedCareers',
    props: true
  },
  {
    path: '/career/:code/detail',
    component: components.CareerDetail,
    name: 'careerDetail',
    props: true
  },
  {
    path: '/career/:code/programs',
    component: components.CareerPrograms,
    name: 'careerPrograms',
    props: true
  },
  {
    path: '/career/:code/pathways',
    component: components.CareerPathways,
    name: 'careerPathways',
    props: true
  },
  {
    path: '/career/:code/insights',
    component: components.CareerAlumniInsights,
    name: 'careerAlumniInsights',
    props: true
  }
]



// WEBPACK FOOTER //
// ./src/app/career/routes.js